module.exports = __webpack_public_path__ + "static/media/child_usage1.950a03ae.png";